import noop from '~/utils/noop';
import { IHydratedAdaptor, TAllMethodKeys } from './types';

type TUntrackedMethods = (
  adaptor: IHydratedAdaptor,
  untrackedMethods: TAllMethodKeys,
) => IHydratedAdaptor;
export const untrackMethods: TUntrackedMethods = (
  adaptor,
  untrackedMethods,
) => {
  untrackedMethods.forEach(m => {
    adaptor[m] = noop;
  });

  return adaptor;
};

export default untrackMethods;
